import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import IsSignedInRoute from "./components/IsSignedInRoute";
import Loading from "./components/Loading";
import PrivateRoute from "./components/PrivateRoute";
import EditProfile from "./components/Profile/EditProfile";
import Profile from "./components/Profile/Profile";
import UserProfile from "./components/Profile/UserProfile";
import ForgotPassword from "./pages/auth/ForgotPassword";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import HomePage from "./pages/HomePage";
import AddPostPage from "./pages/Posts/AddPostPage";
import PostsPage from "./pages/Posts/PostsPage";
import SinglePostPage from "./pages/Posts/SinglePostPage";
import ProfilePage from "./pages/profile/ProfilePage";
import UserProfilePage from "./pages/profile/UserProfilePage";
import VerifyPage from "./pages/profile/VerifyPage";
import { useUIContext } from "./store/contexts/ui.context";

function App() {
  const { loading: loader } = useUIContext();
  const [loading, setloading] = useState(true);

  useEffect(() => {
    setloading(loader);
  }, [loader]);

  return (
    <>
      {loading && <Loading />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/posts" element={<PostsPage />} />
        <Route path="/posts/:id" element={<SinglePostPage />} />
        <Route
          path="/add-post"
          element={
            <PrivateRoute>
              <AddPostPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        >
          <Route index element={<Profile />} />
          <Route path="edit" element={<EditProfile />} />
        </Route>
        <Route
          path="/profile/verify"
          element={
            <PrivateRoute>
              <VerifyPage />
            </PrivateRoute>
          }
        />
        <Route path="/profile/:id" element={<UserProfilePage />} />
        <Route
          path="/signin"
          element={
            <IsSignedInRoute>
              <SignIn />
            </IsSignedInRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <IsSignedInRoute>
              <SignUp />
            </IsSignedInRoute>
          }
        />
        <Route
          path="/recovery"
          element={
            <IsSignedInRoute>
              <ForgotPassword />
            </IsSignedInRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
